import React, { useEffect, useRef, useState } from 'react'
import { FlashMessage, GlobalLoader, InputField, Modal } from '@reactiveonline/reactive_admin_shared-packages'
import LanguagePicker from '../shared/LanguagePicker'

export default function New({ adminInterfaceLogo, applicationName, confirmationPath, forgotPasswordPath, loginPath, unlockMessage }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [otp, setOtp] = useState(['', '', '', '', '', ''])
  const [showOtpModal, setShowOtpModal] = useState(false)
  const [successfulEmail, setSuccessfulEmail] = useState(null)
  const [successfulPass, setSuccessfulPass] = useState(null)
  const [otpFocus, setOtpFocus] = useState(0)
  const [loading, setLoading] = useState(false)
  const [pasted, setPasted] = useState(false)
  const [backspacePressed, setBackspacePressed] = useState(false)

  const flashMessageRef = useRef(null)

  useEffect(() => {
    if (unlockMessage) {
      flashMessageRef.current.show(unlockMessage)
    }
  }, [])

  const sendOtp = () => {
    const fd = new FormData()

    const currentEmail = email
    const currentPass = password

    fd.append('email', currentEmail)
    fd.append('password', currentPass)

    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: confirmationPath,
      dataType: 'json',
      data: fd,
      success: res => {
        flashMessageRef.current.show(res.message)
        setShowOtpModal(true)
        setSuccessfulEmail(currentEmail)
        setSuccessfulPass(currentPass)
        setLoading(false)
      },
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
        setLoading(false)
      }
    })
  }

  const closeOtpModal = () => {
    setShowOtpModal(false)
    setSuccessfulEmail(false)
    setSuccessfulPass(false)
    setOtpFocus(0)
    setOtp(['', '', '', '', '', ''])
  }

  const login = () =>{
    const fd = new FormData()

    fd.append('administrator[email]', successfulEmail)
    fd.append('administrator[password]', successfulPass)
    fd.append('otp', otp.join(''))

    setLoading(true)

    Rails.ajax({
      type: 'POST',
      url: loginPath,
      dataType: 'json',
      data: fd,
      success: res => window.location.href = res.redirectUrl,
      error: res => {
        flashMessageRef.current.show(res.error, 'error')
        setLoading(false)
      }
    })
  }

  const handleOtpChange = (index, e) => {
    if (pasted) {
      setPasted(false)
    } else if (backspacePressed) {
      setBackspacePressed(false)
    } else {
      setOtp(prevState => [
        ...prevState.slice(0, index),
        e.target.value.slice(-1),
        ...prevState.slice(index + 1),
      ])

      if (e.target.value.slice(-1) !== '') {
        setOtpFocus(Math.min(5, otpFocus + 1))
      }
    }
  }

  const handleOtpPaste = (index, value) => {
    const maxPossibleChanges = 6 - index
    const changes = value.split('').slice(0, maxPossibleChanges)

    setOtp(prevState => [
      ...prevState.slice(0, index),
      ...changes,
      ...prevState.slice(index + changes.length)
    ])

    setOtpFocus(Math.min(5, otpFocus + changes.length))
    setPasted(true)
  }

  const handleKeyDownPress = (index, e) => {
    if (e.code === 'Backspace' && otp[index] === '') {
      setBackspacePressed(true)
      setOtpFocus(Math.max(0, index - 1))
    }
  }

  return (
    <>
      <div className='flex-box flex-column items-center content-center authentication-wrapper'>
        <div className="auth-box">
          <div className="left-side-wrapper">
            <div className="logo">
              <img src={ adminInterfaceLogo } />
            </div>

            <div className='authentication-language-picker-wrapper'>
              <LanguagePicker />
            </div>

            <div className="headline">
              <h1>{ applicationName }</h1>
              <div>{ Partners.translations.app_welcome }</div>
            </div>
            <div className="form">
              <div className="row">
                <div className="field">
                  <InputField
                    className='input-field col s12'
                    label={ Partners.translations.administrator.attributes.email }
                  >
                    <input
                      type='email'
                      value={ email }
                      onChange={ e => setEmail(e.target.value) }
                    />
                  </InputField>
                </div>
                <div className="field">
                  <InputField
                    className='input-field col s12'
                    label={ Partners.translations.administrator.attributes.password }
                  >
                    <input
                      type='password'
                      value={ password }
                      onChange={ e => setPassword(e.target.value) }
                    />
                  </InputField>
                </div>
                <div className="field">
                  <div className='button-wrapper items-center content-center flex-box'>
                    <div
                      className={`btn ${(password.length > 1 && email.length > 1) ? '' : 'disabled' } `}
                      onClick={ (password.length > 1 && email.length > 1) ? sendOtp : ()=> {} }
                    >
                      { ReactiveCore.translations.next }
                    </div>
                  </div>
                </div>

                <div style={{ fontWeight: 0.8 }}>
                  <a 
                    href={ forgotPasswordPath } 
                  >
                    { Partners.translations.administrator.forgot_password }
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


        { showOtpModal &&
          <Modal
            key={ otpFocus }
            visible
            closeModal={ closeOtpModal }
            mode='otp-auth-modal'
            wrapperClasses='otp-auth-modal-wrapper'
          >
            <div className='otp-auth-modal-header'>
              <div className='otp-auth-modal-icon'>
                <i className='fa-light fa-shield-check' />
              </div>
              <div>
                <h2>{ Partners.translations.administrator.attributes.otp }</h2>
                <div className='otp-auth-modal-email'>{ successfulEmail }</div>
              </div>
            </div>

            <div className='otp-auth-code-wrapper'>
              { Array.from(Array(6).keys()).map(item => (
                <input
                  key={ item }
                  type='text'
                  inputMode='numeric'
                  pattern='[0-9]*'
                  autoComplete={ item === 0 ? 'one-time-code' : 'off' }
                  value={ otp[item] }
                  onChange={ e => handleOtpChange(item, e) }
                  autoFocus={ otpFocus === item }
                  onFocus={ _e => setOtpFocus(item) }
                  onPaste={ e => handleOtpPaste(item, e.clipboardData.getData('Text')) }
                  onKeyDown={ e => handleKeyDownPress(item, e) }
                />
              ))}
            </div>

            <div className='otp-auth-modal-actions'>
              <button
                type='button'
                className='btn reverted'
                onClick={ sendOtp }
              >
                { Partners.translations.resend }
              </button>

              <button
                type='button'
                className='btn'
                onClick={ login }
                disabled={ otp.some(el => el === '') }
              >
                { ReactiveCore.translations.confirm }
              </button>
            </div>

            { loading && <GlobalLoader fullPage/> }
          </Modal>
        }

        { loading && <GlobalLoader fullPage/> }

        <FlashMessage ref={ flashMessageRef } />
    </>
  )
}
